import Icon1 from "./Icons/Icon1";
import Icon2 from "./Icons/Icon2";
import Icon3 from "./Icons/Icon3";
import Icon4 from "./Icons/Icon4";
import Icon5 from "./Icons/Icon5";
import Icon6 from "./Icons/Icon6";
import Icon7 from "./Icons/Icon7";

export default function CardKeyDemo({item, onClick, className = '', style = {}, ...rest}) {
    // Validación de props para evitar errores
    if (!item) {
        console.error('Card component: item prop is required');
        return null;
    }

    return (
        <div 
            {...rest}
            onClick={onClick}
            className={`click-effect bg-[#0E2242] rounded-54u border-2u border-[#A9AAB5]
                w-821u h-445u
                relative
                ${className}`}
            style={style}
        >  
            <div className='relative pl-112u pt-80u pr-79u z-10'>
                <div 
                    className="text-96u font-light relative break-words leading-96u mb-135u" 
                    dangerouslySetInnerHTML={{ __html: item.category || '' }}
                />
                
                <div className="
                    absolute
                    w-162u h-162u
                    rounded-full
                    border-20u
                    border-white/20
                    border-b-transparent
                    border-l-transparent
                    transform
                    -left-2u top-47u
                    -translate-x-1/2
                    rotate-[-135deg]
                    z-0">
                </div>
                
                <div className="
                    absolute
                    w-118u h-118u rounded-full
                    bg-[#07182D]
                    flex items-center justify-center
                    transform
                    left-0 top-68u -translate-x-1/2">
                        {item.id === 1 && (
                        <Icon1 className="w-64u h-auto" />
                        )}
                        {item.id === 2 && (
                        <Icon2 className="w-88u h-auto" />
                        )}
                        {item.id === 3 && (
                        <Icon3 className="w-72u h-auto" />
                        )}
                        {item.id === 4 && (
                        <Icon4 className="w-72u h-auto" />
                        )}
                        {item.id === 5 && (
                        <Icon5 className="w-65u h-auto" />
                        )}
                        {item.id === 6 && (
                        <Icon6 className="w-62u h-auto" />
                        )}
                        {item.id === 7 && (
                        <Icon7 className="w-56u h-auto" />
                        )}

                </div>
            </div>
        </div>
    );
};
